import { Component, OnInit, Input } from '@angular/core';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'ngx-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss']
})
export class ContractorComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  loading = false;
  employees = [];
  files: any = [];
  data: any = {
    requirements: [
      {
        "name": "registros_identificacion_personal",
        "complete_name": "Registros e identificacion del personal que ingresa al area de trabajo por medio de credenciales para evitar personal ajeno y/o cambio de personal sin previo aviso",
        "value": null
      },
      {
        "name": "presentar_registro_personal",
        "complete_name": "Presentar el registro de personal asegurado (contratistas)",
        "value": null
      },
      {
        "name": "presentar_constancia_habilidades",
        "complete_name": "Presentar constancia de habilidades para el servicio presentado (DC3)",
        "value": null
      },
      {
        "name": "control_visitas",
        "complete_name": "Registro en control de visitas",
        "value": null
      }
    ],
    other_requirements: [
      {
        complete_name: '',
        value: null,
      }
    ],
    industrial_security: [
      {
        "name": "equipo_proteccion_personal",
        "complete_name": "Equipo de protección personal general y específico de acuerdo con las actividades a ejecutar",
        "value": null
      },
      {
        "name": "seguridad_de_equipos",
        "complete_name": "Seguridad de equipos y maquinaria",
        "value": null
      },
      {
        "name": "señalizacion",
        "complete_name": "Señalización",
        "value": null
      },
      {
        "name": "orden_y_limpieza",
        "complete_name": "Orden y limpieza",
        "value": null
      },
      {
        "name": "plan_de_respuesta",
        "complete_name": "Plan de respuesta o emergencias",
        "value": null
      },
      {
        "name": "competencia_formacion",
        "complete_name": "Competencia, formación, toma de conciencia, inducción y capacitación del personal que ejecutará las actividades para las cuales se está contratando",
        "value": null
      },
      {
        "name": "productos_quimicos",
        "complete_name": "Productos químicos y/o peligrosos necesarios para las actividades proyectadas",
        "value": null
      },
      {
        "name": "identificacion_de_peligros",
        "complete_name": "Identificación de peligros y valoración de riesgos inherentes a las actividades",
        "value": null
      }
    ],
    other_industrial_security: [
      {
        complete_name: '',
        value: null,
      }
    ],
    operational_security: [
      {
        "name": "cumplimiento_correcto_de_procedimientos",
        "complete_name": "Cumplimiento correcto de los procedimientos operativos y de mantenimiento por parte del personal",
        "value": null
      },
    ],
    other_operational_security: [
      {
        complete_name: '',
        value: null,
      }
    ],
    environmental_protection: [
      {
        "name": "autorizaciones_y_permisos",
        "complete_name": "Autorizaciones y permisos (cuando aplique) para las actividades a ejecutar",
        "value": null
      },
      {
        "name": "restricciones_sobre_vertimientos",
        "complete_name": "Restricciones sobre posibles vertimientos de sustancias nocivas, líquidas, aguas sucias, meteriales y/o residuos a mares, ríos, lagunas, pantanos y otro bien nacional",
        "value": null
      },
      {
        "name": "manejo_integral_residuos",
        "complete_name": "Manejo integral de la basura, chatarra, residuos peligrosos o cualquier otro residuo indicado en la Normatividad Ambiental Vigente",
        "value": null
      },
    ],
    other_environmental_protection: [
      {
        complete_name: '',
        value: null,
      }
    ],
  };
  today = new Date();
  year = moment(this.today).format('YYYY')

  constructor(
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<ContractorComponent>,
  ) { }

  async ngOnInit() {
    this.loading = true
    if (this.action === 'edit') {
      this.stationId = this.infoEdit.station_id
    }
    await this.checkIfCreateOrEdit()
    this.loading = false
  }

  async store() {
    this.data.station_id = this.stationId
    this.data.date = moment(this.data.date).format('YYYY-MM-DD')
    this.loading = true;
    const [error, response] = await this.sasisopaService.createContractor(this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato creado con éxito', 'success');
    this.ref.close(true);
  }

  async editFormat() {
    this.loading = true
    const [error, response] = await this.sasisopaService.editContractor(this.infoEdit.id, this.data)
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false
    await this.alert('Formato editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data.station_id = this.infoEdit.station_id
      this.data.date = moment(this.infoEdit.date).toDate()
      this.data.contractor = this.infoEdit.contractor
      this.data.development_stage = this.infoEdit.development_stage
      this.data.requirements = this.infoEdit.requirements
      this.data.other_requirements = this.infoEdit.other_requirements
      this.data.industrial_security = this.infoEdit.industrial_security
      this.data.other_industrial_security = this.infoEdit.other_industrial_security
      this.data.operational_security = this.infoEdit.operational_security
      this.data.other_operational_security = this.infoEdit.other_operational_security
      this.data.environmental_protection = this.infoEdit.environmental_protection
      this.data.other_environmental_protection = this.infoEdit.other_environmental_protection
    }
  }

  addGeneralRequirements() {
    this.data.other_requirements.push({
      complete_name: '',
      value: null
    })
  }

  addIndustrialSecurity() {
    this.data.other_industrial_security.push({
      complete_name: '',
      value: null
    })
  }

  addEnvironmentalProtectionRequirement() {
    this.data.other_environmental_protection.push({
      complete_name: '',
      value: null
    })
  }

  addOperationalSecurityRequirement() {
    this.data.other_operational_security.push({
      complete_name: '',
      value: null
    })
  }

}
